import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";
import { ITagHistory } from "../../services/tag-data-service/Models";
import { ITagAndTatID } from "../../services/tag-value-data-service/Models";
import TagValueDataService from "../../services/tag-value-data-service/TagValueDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseTagValuesChartsQueryParams = {
    customerID: number;
    groupID: number;
    objectID: number;
    objectType: eLynxObjectTypeEnum;
    tagAndTatIDs: Array<ITagAndTatID>;
    startDate: Date | undefined;
    endDate: Date | undefined;
    offline: boolean;
} & BaseUseQueryParameters<ITagHistory>;

export function useTagValuesCharts(params: UseTagValuesChartsQueryParams) {
    const entity = {
        id: params.objectID,
        objectType: params.objectType
    } as IeLynxObject;

    return useQuery<ITagHistory | undefined, RestError>(
        keys.data(params.customerID,
            params.groupID,
            entity,
            params.tagAndTatIDs,
            params.startDate,
            params.endDate,
            params.offline
            ),
            ({ signal }) => {
                return TagValueDataService.getTagValueCharts(params.customerID, params.groupID, entity, params.tagAndTatIDs, params.startDate, params.endDate, params.offline, signal);
            },
            {
                enabled: params.enabled,
                onError: params.onError,
                onSuccess: params.onSuccess,
                refetchInterval: params.refreshSeconds ? params.refreshSeconds * 1000 : false
            }
    )
}